<template>
    <div>
        <div class="marketo-form">
            <Typography class="title" variant="h3-display" as="h3">{{ $t('Подпишитесь') }}</Typography>
            <Typography class="description" variant="body-display-small" as="p">{{
                formDescriptionRussian
            }}</Typography>
            <form id="mktoForm_1013"></form>
            <div id="confirmFormCTWEngage" style="display: none">
                <p>
                    Пожалуйста, проверьте электронную почту. Для подтверждения регистрации пройдите по ссылке в письме,
                    которое мы Вам отправили.
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    formContextData: {
        type: Object,
    },
    formDescriptionRussian: {
        type: String,
        default:
            'Подпишитесь, чтобы получать аналитику экспертов Фонда Карнеги за международный мир на тему России и Евразии на ваш электронный адрес',
    },
});
const { locale } = useLocale();
function formEditorNoteRu() {
    MktoForms2.loadForm('//Pages.carnegieendowment.org', '813-XYU-422', 1013, function (form) {
        // Set values for the hidden fields, "Site_Source__c"
        // Note that these fields were configured in the form editor as hidden fields already
        form.vals({ Site_Source__c: 'CMC SubscribePage Mkto Ru' });
    });
    MktoForms2.whenReady(function (form) {
        //Add an onSubmit to add hidden field values
        form.onSubmit(function (form) {
            form.addHiddenFields({ nonEnglishNewsletterAll: 'cmcRussian' });
            form.addHiddenFields({ centerAffiliationAll: 'moscow' });
        });
        //Add an onSuccess handler
        form.onSuccess(function (values, followUpUrl) {
            //get the form's jQuery element and hide it
            form.getFormElem().hide();
            document.getElementById('confirmFormCTWEngage').style.display = 'block';
            //return false to prevent the submission handler from taking the lead to the follow up url.
            return false;
        });
    });
}
onMounted(() => {
    (function(){
        function doOrQueueFormsStuff() {
            if (typeof MktoForms2 != "object") {
                document.addEventListener("load", doOrQueueFormsStuff, true);
            } else if (!doOrQueueFormsStuff.done) {
                document.removeEventListener("load", doOrQueueFormsStuff, true);
                doOrQueueFormsStuff.done = true;
                formEditorNoteRu();
            }
        }
        doOrQueueFormsStuff();
    })();
});
</script>

<style lang="scss" scoped>
@import './././assets/styles/core/marketoForms';
</style>
